import React, { useCallback } from 'react'
import { Link } from 'react-router-dom'
import t from '~t'
import config from '~config'
import { target } from '~target'

import { Button, Icon } from '~ui'

const BookmarksEmptyView = React.memo(function BookmarksEmptyView({
    status,
    spaceId,
    searchEmpty,
    compact,
    collection: { title },
    actions
}) {
    const refresh = useCallback(
        e => {
            e.preventDefault()
            actions.refresh(spaceId)
        },
        [actions, spaceId]
    )

    let content = null

    if (spaceId == -101) return null

    switch (status.main) {
        case 'empty': {
            const _id = parseInt(spaceId)

            switch (true) {
                //trash
                case _id == -99:
                    content = (
                        <div>
                            <h2>{t.s('trashEmpty')}</h2>
                        </div>
                    )
                    break

                //search nothing found
                case !searchEmpty:
                    if (!compact)
                        content = (
                            <div>
                                <h2>{t.format('nothingFoundIn', title)}</h2>
                            </div>
                        )
                    break

                //noBookmarks
                default:
                    if (!compact)
                        content = (
                            <div>
                                <h2>{t.s('noBookmarks')}</h2>
                                <p>
                                    {t.s('noItemsTip')}
                                </p>

                                {target != 'extension' && (
                                    <>
                                        <br />
                                        <Button
                                            as='a'
                                            href={config.links.download}
                                            target='_blank'
                                            variant='outline'>
                                            <Icon name='open' size='micro' />
                                            {t.s('installBrowserExtension')}
                                        </Button>
                                    </>
                                )}

                                <br /><br />

                                <Button
                                    as={Link}
                                    to='/settings/import'
                                    variant='outline'>
                                    <Icon name='cloud' size='micro' />
                                    {t.s('importBookmarks')}
                                </Button>
                            </div>
                        )
                    break
            }
            break
        }

        case 'notFound':
            content = (
                <div>
                    <h2>{t.s('removeCollectionSuccess')}</h2>
                    <p>
                        {t.s('orNothingFound')}
                    </p>

                    <br />

                    <p>
                        <Link to='/my/0'>{t.s('allBookmarks')}</Link>
                    </p>
                </div>
            )
            break

        case 'error':
            content = (
                <div>
                    <h2>⚠️ {t.s('error')}</h2>
                    <p>
                        <a href='' onClick={refresh}>{t.s('refresh')}</a>
                    </p>
                </div>
            )
            break
    }

    return (
        <div className={'ui-bm-empty'}>
            {content}
        </div>
    )
})

export default BookmarksEmptyView
